import React from "react";
import PropTypes from "prop-types";

function Footer({ ...props }) {
  return (
    <div className="footer">
      <a href="http://www.pccwglobal.com" target="_blank"> © {new Date().getFullYear()}, PCCW Global</a>
    </div>
  );
}

Footer.propTypes = {
  classes: PropTypes.object
};

export default (Footer);
